import {createAction, props} from '@ngrx/store';

export const VideoUserVolumeUpdateAction = createAction('[Video] - User Volume Update',
    props<{ changedUserVolume: number }>());

export const VideoFullScreenStateUpdateAction = createAction('[Video] - Full Screen State Update',
    props < {fullScreenState: number}>());

export const VideoUserResolutionUpdateAction = createAction('[Video] - Resolution Update',
    props < {changedResolution: string}>());

export const VideoTimelineVisibilityUpdateAction = createAction('[Video] - Timeline Visibility Update',
    props < {changedVisibility: boolean}>());

export const VideoResolutionMenuVisibilityAction = createAction('[Video] - Resolution Menu Visibility Update',
    props < {changedVisibility: boolean}>());

export const AddResolutionToNotAvailableTable = createAction('[Video] - Add Resolution To Not Available Table',
    props < {resolution: string}>());
